document.addEventListener('DOMContentLoaded', function () {
  const shortDescription = document.getElementById('shortDescription');
  const shortDescriptionInner = document.getElementById('shortDescriptionInner');
  const fullDescription = document.getElementById('fullDescription');
  const readMoreBtn = document.getElementById('readMoreBtn');
  const readLessBtn = document.getElementById('readLessBtn');

  if (!shortDescription || !fullDescription || !shortDescriptionInner) return;

  const isContentOverflowing = shortDescriptionInner.scrollHeight > shortDescriptionInner.offsetHeight;

  if (isContentOverflowing && readMoreBtn) {
    readMoreBtn.style.display = 'inline';
  }

  readMoreBtn?.addEventListener('click', function () {
    shortDescription.style.display = 'none';
    fullDescription.style.display = 'block';
  });

  readLessBtn?.addEventListener('click', function () {
    shortDescription.style.display = 'block';
    fullDescription.style.display = 'none';
  });
});